import isNil from 'lodash.isnil'

import { FeeType, PaymentMethod } from '../../types/graphql'

import { formatNumber, NumberFormat } from './number'

export const formatFee = (fee: string | number | null | undefined): string => {
  let dividedAmount = 0
  if (!isNil(fee)) {
    dividedAmount = typeof fee === 'string' ? parseFloat(fee) / 100 : fee / 100
  }

  return formatNumber(dividedAmount, { format: NumberFormat.Currency })
}

export const convertCentsToDollars = <T extends number | null | undefined>(cents: T): T => {
  if (isNil(cents)) {
    return cents
  }

  const dollars = (cents as number) / 100
  return parseFloat(dollars.toFixed(2)) as T
}

export const convertRawFeeToCents = (fee: string | number): number => {
  let dollars: number
  if (typeof fee === 'string') {
    dollars = parseFloat(fee)
  } else {
    dollars = fee
  }
  const cents = dollars * 100
  return Math.round(cents)
}

export const formatPaymentMethod = (
  paymentMethod: PaymentMethod | undefined,
  paymentProviderFormatted: string
): string => {
  if (!paymentMethod) {
    return ''
  }
  switch (paymentMethod) {
    case 'ACH':
      return 'ACH'
    case 'Cash':
      return 'Cash'
    case 'Check':
      return 'Check'
    case 'Credit': {
      return 'Credit Card'
    }
    case 'External': {
      return paymentProviderFormatted
    }
    case 'ExternalCardReader': {
      return 'External Card Reader'
    }
    case 'ExternalCreditCard': {
      return `${paymentProviderFormatted} (Credit Card)`
    }
    case 'ExternalACH': {
      return `${paymentProviderFormatted} (E-Check)`
    }
  }
}

export const DefaultAllowedFeeTypes: FeeType[] = [
  'Calculated',
  'Dropdown',
  'Fixed',
  'Manual',
  'Percent',
  'Range',
  'Valuation',
]
